import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Button,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import {
  AccessTime as TimeIcon,
  Euro as EuroIcon
} from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';

const ServicesList = ({ services, onBookService, isMobile = false }) => {
  const { t } = useTranslation();
  if (!services || services.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('salon.noServicesConfigured')}
      </Typography>
    );
  }

  if (isMobile) {
    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#000000' }}>
          {t('salon.servicesAndPrices')}
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {services.map((service, index) => (
            <Card key={service.id || index} sx={{ borderRadius: 2, border: '1px solid #E5E7EB' }}>
              <CardContent sx={{ p: 2.5 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1, color: '#000000' }}>
                      {service.name}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                      <Chip 
                        onClick={() => {}}
                        icon={<TimeIcon />}
                        label={`${service.duration} min`} 
                        size="small" 
                        variant="outlined"
                        sx={{ fontSize: '0.75rem' }}
                      />
                      <Chip 
                        onClick={() => {}}
                        icon={<EuroIcon />}
                        label={`${service.price}€`} 
                        size="small" 
                        sx={{ 
                          backgroundColor: '#F5F5DC', 
                          color: '#000000',
                          fontSize: '0.75rem',
                          fontWeight: 500
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => onBookService(service)}
                  sx={{
                    backgroundColor: '#000000',
                    color: '#FFFFFF',
                    borderRadius: 2,
                    py: 1.5,
                    fontWeight: 500,
                    '&:hover': {
                      backgroundColor: '#1F1F1F'
                    }
                  }}
                >
                  {t('salon.bookThisService')}
                </Button>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    );
  }

  // Desktop version
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          {t('salon.servicesAndPrices')}
        </Typography>
        
        <List>
          {services.map((service, index) => (
            <ListItem key={service.id || index} divider={index < services.length - 1}>
              <ListItemText
                primary={service.name}
                secondary={
                  <Box display="flex" gap={1} mt={1}>
                    <Chip 
                      onClick={() => {}}
                      label={`${service.duration} min`} 
                      size="small" 
                      variant="outlined" 
                    />
                    <Chip 
                      onClick={() => {}}
                      label={`${service.price}€`} 
                      size="small" 
                      sx={{ backgroundColor: '#f5f5dc' }}
                    />
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default ServicesList;